import { gql } from '@apollo/client';

export const getCheckoutHealthOffer = gql`query checkoutHealthOffer($offerId: String!, $soId: String!) {
  checkoutHealthOffer(id: $offerId) {
    _id
    soId
    status
    brandId
    paidAt
    isPublished
    termsAcceptedAt
    iddTermsAcceptedAt
    allianzGDPRAcceptedAt
    acceptedEmailDocumentationDeliveryAt
    annotations
    supplementary {
      label
      actionLabel
      brandName
      brandCode
      code
      numberOfInstallments
      baseProductPrice
      logoUrl
      priceChangeModifier { amount type description }
      voucherPriceModifier { amount }
      voucherPriceChangeModifier { amount type description code }
      visual { highlight tooltip description }
      fixedCoverages { label tooltip value price gratis { value type } options { key value } }
      coverages { label tooltip value price gratis { value type } options { key value } }
      discounts { value tooltip }
      paymentSlipInfo { amount numOfInstallments }
      total { generalTransfer generalTransferWithInstallments creditCard creditCardWithInstallments }
      includedInPrice { label description }
      additionalCoverages { label description }
    }
    additional {
      label
      actionLabel
      brandName
      brandCode
      code
      numberOfInstallments
      baseProductPrice
      logoUrl
      priceChangeModifier { amount type description }
      voucherPriceModifier { amount }
      voucherPriceChangeModifier { amount type description code }
      visual { highlight tooltip description }
      fixedCoverages { label tooltip value price gratis { value type } options { key value } }
      coverages { label tooltip value price gratis { value type } options { key value } }
      discounts { value tooltip }
      paymentSlipInfo { amount numOfInstallments }
      total { generalTransfer generalTransferWithInstallments creditCard creditCardWithInstallments }
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
  }
  checkoutHealthOfferData(id: $offerId) {
    karenca
    hasPolicy
    newPolicyStartDate
    newPolicyStartDateNote
    productCode
    insuredPerson {
      firstName { value isEditable }
      lastName { value isEditable }
      birthDate { value isEditable }
      gender { value isEditable }
      streetAndHouseNumber { value isEditable }
      street { value isEditable }
      streetKompareId { value isEditable }
      houseNumber { value isEditable }
      city { value isEditable }
      cityKompareId { value isEditable }
      zipCode { value isEditable }
      oib { value isEditable }
      insuranceNumber { value isEditable }
      personalIdNumber { value isEditable }
      personalIdIssuer { value isEditable }
      partnerContactEmail { value isEditable }
    }
    contractor {
      personType
      isSamePerson
      person {
        firstName { value isEditable }
        lastName { value isEditable }
        birthDate { value isEditable }
        gender { value isEditable }
        streetAndHouseNumber { value isEditable }
        street { value isEditable }
        streetKompareId { value isEditable }
        houseNumber { value isEditable }
        city { value isEditable }
        cityKompareId { value isEditable }
        zipCode { value isEditable }
        oib { value isEditable }
        partnerContactEmail { value isEditable }
      }
      company {
        companyName { value isEditable }
        oib { value isEditable }
        streetAndHouseNumber { value isEditable }
        street { value isEditable }
        houseNumber { value isEditable }
        streetKompareId { value isEditable }
        city { value isEditable }
        cityKompareId { value isEditable }
        zipCode { value isEditable }
        partnerContactEmail { value isEditable }
      }
    }
    delivery {
      asEntity { value isEditable }
      name { value isEditable }
      streetAndHouseNumber { value isEditable }
      street { value isEditable }
      streetKompareId { value isEditable }
      houseNumber { value isEditable }
      city { value isEditable }
      cityKompareId { value isEditable }
      zipCode { value isEditable }
    }
  }
  getTermsAndConditionsFromFiles(id: $offerId) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  }
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  personalVoucherStatus(soId: $soId) {
    value
    code
    type
    description
    campaignName
    name
    generatedUniqueCodes
    startDate
    endDate
    status
  }
}
`;
